import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { Typography } from '@material-ui/core'
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet'

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  icon: {
    color: theme.palette.primary.main,
    marginRight: theme.spacing(1)
  }
}))

const ExToolbar = props => {
  const { className, ...rest } = props
  const classes = useStyles()

  return (
    <div
      {...rest}
      className={classes.root}
    >
      <div className={classes.row}>
        <Typography
          className={classes.title}
          variant="h4"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <AccountBalanceWalletIcon className={classes.icon} />
          Penarikan Komisi
        </Typography>
      </div>
    </div>
  )
}

ExToolbar.propTypes = {
  className: PropTypes.string
}

export default ExToolbar
